import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  /**
   * Boolean value to display back link
   */
  @Input() hasBackButton = false;

  constructor(private location: Location) {}

  /**
   * Navigate to route on click
   */
  onBackLinkClick() {
    this.location.back();
  }
}
